'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Helper component. Update the body background
// according to the `background` prop.
var BodyBackground = function (_React$Component) {
  _inherits(BodyBackground, _React$Component);

  function BodyBackground(props) {
    _classCallCheck(this, BodyBackground);

    var _this = _possibleConstructorReturn(this, (BodyBackground.__proto__ || Object.getPrototypeOf(BodyBackground)).call(this, props));

    _this.useBackground(props.background);
    return _this;
  }

  _createClass(BodyBackground, [{
    key: 'useBackground',
    value: function useBackground(prop) {
      var body = document.querySelector('body');
      body && (body.style.background = prop);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.background !== this.props.background) {
        this.useBackground(nextProps.background);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }

    // Don't render anything

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return BodyBackground;
}(_react2.default.Component);

BodyBackground.propTypes = {
  background: _propTypes2.default.string
};


var GlobalBackground = function GlobalBackground(props) {
  var color = props.theme.backgroundColor;

  if (props.isFullscreen) {
    color = props.theme.fullscreenBackgroundColor;
  }

  return _react2.default.createElement(BodyBackground, { background: color });
};

exports.default = (0, _styledComponents.withTheme)(GlobalBackground);